import * as React from 'react';
import {MouseEvent, useEffect, useState} from 'react';
import {DefaultLinkPointWidget, DefaultLinkProps, LinkWidget} from "@projectstorm/react-diagrams";
import {PointModel} from "@projectstorm/react-diagrams-core";
import {LinkSegmentWidget} from "./segments/LinkSegmentWidget";

export const NodeLinkWidget = (props: DefaultLinkProps) => {

    const [selected, setSelected] = useState(false);
    //ensure id is present for all points on the path
    const points = props.link.getPoints();
    const paths = [];
    const refPaths: React.RefObject<SVGPathElement>[] = [];

    useEffect(()=>{
            props.link.setRenderedPaths(
                refPaths.map((ref:any) => {
                    return ref.current;
                })
            );
            return ()=>{
                props.link.setRenderedPaths([]);
            }
    }, [])

    const renderPoints = () => {
        return props.renderPoints ?? true;
    }

    const addPointToLink = (event: MouseEvent, index: number) => {
        if (
            !event.shiftKey &&
            !props.link.isLocked() &&
            props.link.getPoints().length - 1 <= props.diagramEngine.getMaxNumberPointsPerLink()
        ) {
            const point = new PointModel({
                link: props.link,
                position: props.diagramEngine.getRelativeMousePoint(event)
            });
            props.link.addPoint(point, index);
            event.persist();
            event.stopPropagation();
                props.diagramEngine.getActionEventBus().fireAction({
                    event,
                    model: point
                });
            // forceUpdate(() => {
            //     props.diagramEngine.getActionEventBus().fireAction({
            //         event,
            //         model: point
            //     });
            // });
        }
    }

    const generatePoint = (point: PointModel): JSX.Element => {
        return (
            <DefaultLinkPointWidget
                key={point.getID()}
                point={point as any}
                colorSelected={props.link.getOptions().selectedColor || ""}
                color={props.link.getOptions().color}
            />
        );
    }

    const generateLink = (path: string, extraProps: any, id: string | number): JSX.Element => {
        const ref = React.createRef<SVGPathElement>();
        refPaths.push(ref);
        return (
            <LinkSegmentWidget
                key={`link-${id}`}
                path={path}
                selected={selected}
                diagramEngine={props.diagramEngine}
                factory={props.diagramEngine.getFactoryForLink(props.link)}
                link={props.link}
                forwardRef={ref}
                onSelection={(selected: boolean | ((prevState: boolean) => boolean)) => {
                 //   console.log('on select link !')
                    setSelected(selected);
                }}
                extras={extraProps}
            />
        );
    }


    if (points.length === 2) {
        paths.push(
            generateLink(
                props.link.getSVGPath(),
                {
                    onMouseDown: (event: React.MouseEvent<Element, globalThis.MouseEvent>) => {
                        addPointToLink(event, 1);
                    }
                },
                '0'
            )
        );

        // draw the link as dangeling
        if (props.link.getTargetPort() === null) {
            paths.push(generatePoint(points[1]));
        }
    } else {
        //draw the multiple anchors and complex line instead
        for (let j = 0; j < points.length - 1; j++) {
            paths.push(
                generateLink(
                    LinkWidget.generateLinePath(points[j], points[j + 1]),
                    {
                        'data-linkid': props.link.getID(),
                        'data-point': j,
                        onMouseDown: (event: MouseEvent) => {
                            addPointToLink(event, j + 1);
                        }
                    },
                    j
                )
            );
        }

        if (renderPoints()) {
            //render the circles
            for (let i = 1; i < points.length - 1; i++) {
                paths.push(generatePoint(points[i]));
            }

            if (props.link.getTargetPort() === null) {
                paths.push(generatePoint(points[points.length - 1]));
            }
        }
    }

    return <g data-default-link-test={props.link.getOptions().testName}>{paths}</g>;

}
